import { decodeUtf8Base64Url } from "./base64";

// NOTE: NSAI-6847 — the account an access token was issued to: its `sub`
// claim, which the server sets to the user's uuid. Read WITHOUT verifying the
// signature — the client holds no key, and does not need one to tell two of
// the tokens it was handed apart. Never an authorization decision; the server
// verifies every token it is sent. null for anything that is not a JWT with a
// string `sub`.
export const readJwtSubject = (token: string): string | null => {
  const payloadSegment = token.split(".")[1];

  if (!payloadSegment) {
    return null;
  }

  const payloadJson = decodeUtf8Base64Url(payloadSegment);

  if (payloadJson === null) {
    return null;
  }

  try {
    const payload: unknown = JSON.parse(payloadJson);

    return typeof payload === "object" &&
      payload !== null &&
      "sub" in payload &&
      typeof payload.sub === "string"
      ? payload.sub
      : null;
  } catch {
    return null;
  }
};
